module.exports = __webpack_public_path__ + "img/brand(2).c0483e0b.png";